import {useQuery, useQueryClient} from '@tanstack/react-query';
import {apiClient} from '../../../../../utils/api-client';
import {TagsResponse} from '../interface';

function getDocumentTagsRequest(accession: string) {
    return apiClient.get<TagsResponse>({
        path: `editor-documents-service/api/documents/${accession}/tags`
    });
}

export function useDocumentTagsQuery(accession: string) {
    return useQuery({
        queryKey: ['document-tags', accession],
        queryFn: () => getDocumentTagsRequest(accession)
    });
}

export function useDocumentTagsQueryCache() {
    const queryClient = useQueryClient();

    function addTag(accession: string, tag: string, isPrivate: boolean) {
        queryClient.setQueryData(['document-tags', accession], (data?: TagsResponse) => {
            return {
                publicTags: [...(data?.publicTags || []), ...(isPrivate ? [] : [tag])],
                privateTags: [...(data?.privateTags || []), ...(isPrivate ? [tag] : [])]
            };
        });
    }

    function removeTag(accession: string, tag: string, isPrivate: boolean) {
        queryClient.setQueryData(['document-tags', accession], (data?: TagsResponse) => {
            if (!data) {
                return {
                    publicTags: [],
                    privateTags: []
                };
            }

            return {
                publicTags: data.publicTags.filter((t) => isPrivate || t !== tag),
                privateTags: data.privateTags.filter((t) => !isPrivate || t !== tag)
            };
        });
    }

    return {addTag, removeTag};
}
